import { FormEvent } from "react";
import { Form } from "react-bootstrap";
import { TenantModalRequestType, ITenantTemplateFormData } from "./tabs/tenant-template-tab";

interface ITenantTemplateModalContentProps {
  request_type: TenantModalRequestType | undefined;
  rowId: string | undefined;
  templateFormData: ITenantTemplateFormData;
  validated: boolean;
  rawRows: { id: string; is_installation?: boolean; is_global?: boolean; current_tenant_default?: boolean; archived?: boolean }[];
  onFormDataChange: (data: ITenantTemplateFormData) => void;
  onSubmit: (e?: FormEvent<HTMLFormElement>) => void;
  onTenantDefaultSubmit: (e?: FormEvent<HTMLFormElement>) => void;
}

const TenantTemplateModalContent = ({
  request_type,
  rowId,
  templateFormData,
  validated,
  rawRows,
  onFormDataChange,
  onSubmit,
  onTenantDefaultSubmit,
}: ITenantTemplateModalContentProps) => {
  if (!request_type || !rowId) {
    return undefined;
  }

  const row = rawRows.find((r) => r.id === rowId);
  
  const ConfirmForm = ({
    label,
    onFormSubmit = onSubmit,
  }: {
    label: React.ReactNode;
    onFormSubmit?: (e?: FormEvent<HTMLFormElement>) => void;
  }) => (
    <Form noValidate onSubmit={onFormSubmit}>
      <Form.Group className="mb-3">
        <Form.Label>{label}</Form.Label>
      </Form.Group>
    </Form>
  );

  switch (request_type) {
    case "update_name":
      return (
        <Form noValidate validated={validated} onSubmit={onSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Template Name</Form.Label>
            <Form.Control
              required
              type="text"
              placeholder="Enter New template name"
              value={templateFormData.name ?? ""}
              onChange={(e) =>
                onFormDataChange({ ...templateFormData, name: e.target.value })
              }
            />
            <Form.Control.Feedback type="invalid">
              Please provide a template name.
            </Form.Control.Feedback>
          </Form.Group>
        </Form>
      );

    case "assign_default":
      return (
        <ConfirmForm
          label={
            <p>
              Are you sure you want to{" "}
              {row?.is_installation
                ? "unassign this template as installation default?"
                : "assign this template as installation default?"}
            </p>
          }
        />
      );

    case "assign_global":
      return (
        <ConfirmForm
          label={
            <p>
              Are you sure you want to{" "}
              {row?.is_global
                ? "unassign this template as global template?"
                : "assign this template as global template?"}
            </p>
          }
        />
      );

    case "assign":
      return (
        <ConfirmForm
          onFormSubmit={onTenantDefaultSubmit}
          label={
            <p>
              Are you sure you want to{" "}
              {row?.current_tenant_default
                ? "unassign this template as tenant default?"
                : "assign this template as tenant default?"}
            </p>
          }
        />
      );

    case "delete":
      return (
        <span>
          Are you sure you want to {row?.archived ? "delete" : "archive"} this template?
        </span>
      );

    case "unarchive":
      return (
        <ConfirmForm label="Are you sure you want to unarchive this template?" />
      );

    default:
      return undefined;
  }
};

export default TenantTemplateModalContent;